let zooExpertTrackingIsInitialise = false;
function zooExpertTrackingGtm(){
    if (zooExpertTrackingIsInitialise) return;
    if (!sessionStorage.getItem('enable_gtm_track')) return;
    if (!Cookiebot?.consent?.statistics || !Cookiebot?.consent?.marketing) return;
    if (document.readyState === "loading") return;
    zooExpertTrackingIsInitialise = true;

    function getCookie(name) {
        const cookies = document.cookie.split('; ');

        for (let cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');

            if (cookieName === name) {
                return decodeURIComponent(cookieValue);
            }
        }

        return null;
    }

    // funzione check visibilità contenuto
    function onVisible(element, callback) {
        new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0) {
                    callback(element);
                    observer.disconnect();
                }
            });
        }).observe(element);
        if(!callback) return new Promise(r => callback=r);
    }

    // --> tile_sub_menu -> desk
    document.querySelectorAll("#plg-custom-mega-menu .header__menu .mega-menu a").forEach((sub_menu_item, index) => {
        sub_menu_item.addEventListener("click", (e) => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push(
                {
                    'cta_clicked': sub_menu_item.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'Mega Menu Desk',
                    'is_banner': sub_menu_item.dataset?.banner == "true" ? sub_menu_item.dataset?.banner : "false",
                    'full_menu': sub_menu_item.dataset?.level1 + " / " + sub_menu_item.dataset?.level2 + " / " + sub_menu_item.dataset?.level3,
                    'event': 'tile_sub_menu'
                }
            );
        })
    })
    // --> tile_sub_menu -> mob -> check also theme.js
    document.querySelectorAll(".header__menu--nav li").forEach((sub_menu_item, index) => {
        let nav_menu_item = sub_menu_item.querySelector("details") ? sub_menu_item.querySelector("details") : sub_menu_item.querySelector("a")

        nav_menu_item.addEventListener("click", (e) => {
            console.log("test")
            console.log(sub_menu_item.dataset.title)
            window.dataLayer = window.dataLayer || [];
            dataLayer.push(
                {
                    'cta_clicked': sub_menu_item.dataset.title,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'Menu Mob',
                    'is_banner': sub_menu_item.dataset?.banner,
                    'full_menu': sub_menu_item.dataset?.level1 + " / " + this.dataset?.level2 + " / " + this.dataset?.level3,
                    'event': 'tile_sub_menu'
                }
            );
        })
    })

    // --> view_promotion
    document.querySelectorAll(".js-promo").forEach((banner_promo, index) => {
        onVisible(banner_promo, ()=>{
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                'event': 'view_promotion',
                ecommerce: {
                    'items': [
                        {
                            'promotion_id': banner_promo.dataset?.promoId,
                            'promotion_name': banner_promo.dataset?.promoTitolo,
                        }
                    ],
                    'creative_name': banner_promo.dataset?.promoTitolo,
                    'creative_slot': banner_promo.dataset?.promoPos,
                    'promotion_id': banner_promo.dataset?.promoId,
                    'promotion_name': banner_promo.dataset?.promoTitolo,
                    'location_id': sessionStorage.getItem("page-title")
                }
            });
        });
    })

    // --> select_promotion
    document.querySelectorAll(".js-promo a").forEach((banner_promo, index) => {
        banner_promo.addEventListener("click", ()=>{
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                'event': 'select_promotion',
                ecommerce: {
                    'items': [
                        {
                            'promotion_id': banner_promo.dataset?.promoId,
                            'promotion_name': banner_promo.dataset?.promoTitolo,
                        }
                    ],
                    'creative_name': banner_promo.dataset?.label,
                    'creative_slot': banner_promo.dataset?.promoPos,
                    'promotion_id': banner_promo.dataset?.promoId,
                    'promotion_name': banner_promo.dataset?.promoTitolo,
                    'location_id': sessionStorage.getItem("page-title")
                }
            });
        })
    })

    // --> newsletter_ok e form_errors
    let newsletter_form = document.querySelector(".globo-formbuilder form")
    if (newsletter_form) {
        console.log("newsletter")
        newsletter_form.querySelector(".submit").addEventListener("click", ()=>{
            setTimeout(()=>{
                if (newsletter_form.querySelector(".message.success").style.display == "block") {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'newsletter_ok'
                    });
                } else {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'form_id':'newsletter',
                        'errors': 'Field errors',
                        'event': 'form_errors'
                    });
                }
            }, 750)
        })
    }
    let contact_form = document.querySelector(".contact form")
    if (contact_form) {
        contact_form.querySelector("button").addEventListener("click", ()=>{
            contact_form.querySelectorAll("input").forEach((input) => {
                if (input.value == "") {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'form_id':'Contact form',
                        'name': input.getAttribute("name"),
                        'errors': 'Field errors',
                        'event': 'form_errors'
                    });
                }
            })
        })
    }

    // --> view_item_list
    function getProductInfoFromAttributes(dataset,viewFrom = {}){
        const quantity = dataset?.qnt;
        const qntNum = Number(quantity);
        const quantityInt = !isNaN(qntNum) && qntNum > 0 ? qntNum : 1;
        return {
            'item_name': dataset?.title,
            'item_id': dataset?.id,
            'price': dataset?.price / 100.00,
            'item_brand': dataset?.vendor,
            'item_category': dataset?.cat1,
            'item_category2': dataset?.cat2,
            'item_category3': dataset?.cat3,
            'item_category4': dataset?.cat4,
            'item_category5': dataset?.cat5,
            'item_variant': dataset?.variant,
            'item_list_name': dataset?.itemListName,
            'index': dataset?.index,
            'currency': dataset?.currency,
            'quantity': quantityInt,
            'ribbon': dataset?.ribbon,
            'price_type': dataset?.priceType,
            'available': dataset?.available,
            ...viewFrom,
        }
    }
    if (document.querySelectorAll(".template-collection .product-card")) {
        let view_item_list = []
        document.querySelectorAll(".product-card").forEach((product_card) => {
            let product_data = getProductInfoFromAttributes(product_card.dataset)
            view_item_list.push(product_data)
        })
        // View_item_list (PLP)
        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
            'event': 'view_item_list',
            ecommerce: {
                'items': view_item_list
            }
        });
    }
    // let view_item_list = []
    // addEventListener("scroll", (event) => {
    //     if (document.querySelectorAll(".product-card")) {
    //         document.querySelectorAll(".product-card").forEach((product_card, index) => {
    //             onVisible(product_card, ()=>{
    //                 let product_data = {
    //                     'item_name': product_card.dataset.title,
    //                     'item_id': product_card.dataset.id.toString(),
    //                     'price': product_card.dataset.price,
    //                     'item_brand': product_card.dataset.vendor,
    //                     'item_category': product_card.dataset.cat1,
    //                     'item_category2': product_card.dataset.cat2,
    //                     'item_category3': product_card.dataset.cat3,
    //                     'item_category4': product_card.dataset.cat4,
    //                     'item_category5': product_card.dataset.cat5,
    //                     'item_variant': product_card.dataset.variant,
    //                     'item_list_name': product_card.dataset.itemListName,
    //                     'index': product_card.dataset.index,
    //                     'currency': product_card.dataset.currency,
    //                     'quantity': product_card.dataset.qnt,
    //                     'ribbon': product_card.dataset.ribbon,
    //                     'price_type': product_card.dataset.pricetype,
    //                     'available': product_card.dataset.available
    //                 }
    //                 let found = false
    //                 view_item_list.forEach(item => {
    //                     product_data.item_id == item.item_id ? found = true : null
    //                 });
    //                 if (!found) {
    //                     view_item_list.push(product_data)
    //                     dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    //                         dataLayer.push({
    //                             'event': 'view_item_list',
    //                         ecommerce: {
    //                             'items': view_item_list
    //                         }
    //                     });
    //                 }
    //             });
    //         })

    //     }
    // })


    // --> select_item
    if (document.querySelectorAll(".template-collection .product-card")) {
        document.querySelectorAll(".product-card").forEach((product_card, index) => {
            product_card.addEventListener("mousedown", ()=>{
                let view_item_list = []
                let product_data = getProductInfoFromAttributes(product_card.dataset)
                view_item_list.push(product_data)
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'select_item',
                    ecommerce: {
                        'items': view_item_list
                    }
                });
            })
        })
    }

    // --> view_item PDP
    if (document.querySelector(".template-product")) {
        let product_data = document.querySelector(".product-form-wrapper .js-gtm-product")
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'view_item',
            'ecommerce': {
                'items': [getProductInfoFromAttributes(product_data.dataset,{'viewFrom': 'PDP'})]
            }
        })
    }

    // --> view_item QUICK VIEW
    document.addEventListener("quickview:loaded", (event) => {
        let product_data = event?.detail?.element?.querySelector(".js-gtm-product")
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        if (product_data) {
            window.dataLayer.push({
                'event': 'view_item',
                'ecommerce': {
                    'items': [getProductInfoFromAttributes(product_data.dataset,{'viewFrom': 'PDP'})]
                }
            })
        }
    })

    // --> view_item VARIANT CHANGE
    document.addEventListener('productInfo:loaded',function(event){
        const trigger = event?.detail?.trigger;
        if (!trigger) return;

        let productElement = document;

        const quickView = trigger.closest('quick-view');
        if (!quickView) {
            const formId = trigger.getAttribute('form');
            if (!formId) return;

            const form = document.getElementById(formId);
            if (!form) return;

            productElement = form;
        }
        else productElement = quickView;

        let product_data = productElement?.querySelector(".js-gtm-product")
        if (!product_data) return;

        const dataset = product_data?.dataset;
        if (!dataset) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'view_item',
            'ecommerce': {
                'items': [getProductInfoFromAttributes(dataset,{'viewFrom': 'PDP'})]
            }
        })
    });

    // --> add_to_cart
    document.addEventListener('ajaxProduct:added', (event) => {
        if (!('detail' in event)) return;
        const {detail} = event;
        if (!('product' in detail) || !('productForm' in detail) || !('quantity' in detail)) return;

        trackAddToCart(event?.detail?.product,event?.detail?.productForm,event?.detail?.quantity);
    });
    document.addEventListener('cart:updated', (event) => {
        if (!('detail' in event)) return;
        const {detail} = event;
        if (!detail?.cart ||
            !('lastLineUpdated' in detail) ||
            !('lineItem' in detail)
        ) return;
        const {cart, lastLineUpdated,lineItem} = detail;
        const line = parseInt(lastLineUpdated, 10);
        const product = cart.items[line - 1];

        if (cart?.items_added?.length > 0)  {
            const quantity = cart?.items_added[0].quantity;
            trackAddToCart(product,lineItem,quantity);
        }
    })
    function trackAddToCart(product,productForm,quantity=1){
        if (!product || !productForm) return;
        const addToCartType = product?.selling_plan_allocation ? 'Ricorrente' : 'Singola';
        const addToCartTime = product?.selling_plan_allocation?.selling_plan?.name ? product?.selling_plan_allocation?.selling_plan?.name : 'singolo'

        let addToCartZone = 'Standard';
        if (productForm?.closest('.featured-collections') ||
            productForm?.closest('.quick-view')
        ) addToCartZone = 'Quick Add';
        else if (productForm?.closest('.collection-section')) addToCartZone = 'PLP';
        else if (productForm?.closest('.recently-viewed')) addToCartZone = 'Recent Viewes';
        else if (productForm?.closest('.cart-drawer')) addToCartZone = 'MiniCart';
        else if (productForm?.closest('.cart')) addToCartZone = 'Cart';

        const viewFrom = document.querySelector(".template-product") ? "Product Page" : "Quick View"
        const trackingInfo = productForm.querySelector(".js-gtm-product");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'items': [{
                    ...getProductInfoFromAttributes(trackingInfo?.dataset,{'viewFrom': viewFrom}),
                    quantity,
                    'add_to_cart_type': addToCartType,
                    'add_to_cart_zone': addToCartZone,
                    'add_to_cart_time': addToCartTime
                }]
            }
        });
    }

    // --> view_cart
    if (document.querySelector(".template-cart")) {
        const cart = document.querySelector("main-cart");
        if (cart) trackViewCart(cart);
    }
    document.addEventListener('minicart:open', (event) => {
        if (!('detail' in event)) return;
        const { detail } = event;
        if (!detail?.element) return;

        trackViewCart(detail.element,'MiniCart');
    })
    function trackViewCart(cart,cartView = 'Cart'){
        if (!cart) return;
        const dataCartValue = cart.getAttribute('data-cart-value');
        const cents = Number(dataCartValue);
        let totalPrice = dataCartValue
        if (!Number.isNaN(cents)) totalPrice = cents / 100;

        const lineItems = cart.querySelectorAll('.js-gtm-product');

        const cartCookie = getCookie('cart');
        const cartToken = cartCookie?.split('?key=')?.[0];
        const items = [];
        lineItems.forEach(item => {
            items.push(getProductInfoFromAttributes(item.dataset))
        });

        if (!cartToken || cartToken === '') return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'view_cart',
            'cart_view': cartView,
            'basket_value': totalPrice,
            'basket_id': cartToken,
            'ecommerce': {
                'items': items,
            }
        });
    }

    // --> buy_from_brands
    if (document.querySelectorAll(".logo-bar .logo__media a")) {
        document.querySelectorAll(".logo-bar .logo__media a").forEach((logo_brand, index) => {
            logo_brand.addEventListener("click", ()=>{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': logo_brand.getAttribute("href").replace("/collections/", ""),
                    'zone_location':'Homepage',
                    'event': 'buy_from_brands',
                });
            })
        })
    }

    // --> generate_lead
    if (document.querySelector(".contact form")) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const contact_posted = urlParams?.get('contact_posted');
        if(contact_posted) {
            if (contact_posted.includes("true")) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'form_id': 'Contatto Generico',
                    'zone_location': 'Pagina Contatti',
                    'event': 'generate_lead'
                });
            }
        }
    }

    // --> contact_info
    if (document.querySelectorAll(".contact .contact__sidebar a")) {
        document.querySelectorAll(".contact .contact__sidebar a").forEach((contact, index) => {
            contact.addEventListener("click", ()=>{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': contact.getAttribute("href"),
                    'zone_location': 'Pagina Contatti',
                    'event': 'contact_info'
                });
            })
        })
    }

    // --> page_error
    if (document.querySelector(".template-404")) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'errors': '404',
            'event': 'page_error'
        });
    }

    // --> add_to_wishlist
    if (document.querySelectorAll(".product-card")) {
        document.querySelectorAll(".product-card").forEach((product_card, index) => {
            let th_wl_button = product_card.querySelector(".th_wl_col_btn")
            if (th_wl_button) {
                // console.log(th_wl_button)
                let product_data = [{
                    'item_name': product_card.dataset?.title,
                    'item_id': product_card.dataset?.id.toString(),
                    'price': product_card.dataset?.price / 100.00,
                    'item_brand': product_card.dataset?.vendor,
                    'item_category': product_card.dataset?.cat1,
                    'item_category2': product_card.dataset?.cat2,
                    'item_category3': product_card.dataset?.cat3,
                    'item_category4': product_card.dataset?.cat4,
                    'item_category5': product_card.dataset?.cat5,
                    'item_variant': product_card.dataset?.variant,
                    'item_list_name': product_card.dataset?.itemListName,
                    'index': product_card.dataset?.index,
                    'currency': product_card.dataset?.currency,
                    'quantity': product_card.dataset?.qnt,
                    'ribbon': product_card.dataset?.ribbon,
                    'price_type': product_card.dataset?.pricetype,
                    'available': product_card.dataset?.available
                }]
                th_wl_button.addEventListener("click", ()=>{
                    console.log("TO WISHLIST")
                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'add_to_wishlist',
                        ecommerce: {
                            'items': product_data
                        }
                    });
                })

            }
        })

    }

    // --> header_menu
    if (document.querySelectorAll(".announcement__content")) {
        document.querySelectorAll(".announcement__content").forEach((header_menu, index) => {
            header_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': header_menu.querySelector(".announcement-text")?.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'event': 'header_menu'
                });
            })
        })
    }
    if (document.querySelectorAll(".localization .reversed-link")) {
        document.querySelectorAll(".localization .reversed-link").forEach((header_menu, index) => {
            header_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': header_menu.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'event': 'header_menu'
                });
            })
        })
    }
    if (document.querySelectorAll(".topbar a.social_platform")) {
        document.querySelectorAll(".topbar a.social_platform").forEach((header_menu, index) => {
            header_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': header_menu.querySelector("span")?.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'event': 'header_menu'
                });
            })
        })
    }


    // --> main_menu 1
    if (document.querySelectorAll("header .header__navigation .menu__item")) {
        document.querySelectorAll("header .header__navigation .menu__item").forEach((menu_item, index) => {
            menu_item.addEventListener("click", () => {
                console.log("main_menu 1 header")
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': menu_item.querySelectorAll("span")[0]?.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'Header',
                    'event': 'main_menu'
                });
            })
        })
    }
    // --> main_menu 2
    if (document.querySelectorAll("header .header__navigation .header__menu .dropdown a")) {
        document.querySelectorAll("header .header__navigation .header__menu .dropdown a").forEach((menu_item, index) => {
            menu_item.addEventListener("click", () => {
                console.log("main_menu 2")
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': menu_item.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'Header',
                    'event': 'main_menu'
                });
            })
        })
    }

    // --> tile_menu - desk
    if (document.querySelectorAll("#plg-custom-mega-menu .header__menu .menu__item")) {
        document.querySelectorAll("#plg-custom-mega-menu .header__menu .menu__item").forEach((tile_menu, index) => {
            tile_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': tile_menu.dataset?.title,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'Header',
                    'event': 'tile_menu'
                });
            })
        })
    }
    // --> tile_menu - mob
    if (document.querySelectorAll(".custom-menu-button")) {
        document.querySelectorAll(".custom-menu-button").forEach((tile_menu, index) => {
            tile_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': tile_menu.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': 'NavBar Mobile',
                    'event': 'tile_menu'
                });
            })
        })
    }

    // --> footer_menu
    if (document.querySelectorAll(".footer-group .details__content a")) {
        document.querySelectorAll(".footer-group .details__content a").forEach((footer_menu, index) => {
            footer_menu.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': footer_menu.textContent,
                    'section': sessionStorage.getItem("page-title"),
                    'zone_location': window.screen.width < 769 ? "Desktop" : "Mobile",
                    'event': 'footer_menu'
                });
            })
        })
    }

    // --> filter_choice

    if (document.querySelectorAll(".template-collection form.facet-form")) {
        let filter_forms = document.querySelectorAll(".template-collection form.facet-form")
        filter_forms.forEach((filter_form, index) => {
            filter_form.addEventListener("submit", (e) => {
                let filter_inputs = e.target.querySelectorAll("input")
                filter_inputs.forEach((filter_input, index) => {
                    if (filter_input.checked == true) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'cta_clicked': filter_input.value,
                            'full_selection': filter_input.closest('.filter-group-tag')?.querySelector("h4")?.textContent,
                            'zone_location': sessionStorage.getItem("page-title"),
                            'event': 'filter_choice'
                        });
                    }
                })
            })
        })
    }

    // --> sort_type
    if (document.querySelectorAll(".sort-listbox input")) {
        document.querySelectorAll(".sort-listbox input").forEach((sort_type, index) => {
            sort_type.addEventListener("change", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': sort_type.value,
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'sort_type'
                });
            })
        })
    }

    // --> discover_our_story
    if (document.querySelectorAll(".image-with-text a")) {
        document.querySelectorAll(".image-with-text a").forEach((discover_our_story, index) => {
            discover_our_story.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'discover_our_story',
                });
            })
        })
    }

    // --> reviews_check
    if (document.querySelector(".template-product")) {
        if (document.querySelectorAll(".skeepers-reviews .review")) {
            document.querySelectorAll(".skeepers-reviews .review").forEach((reviews_check, index) => {
                reviews_check.addEventListener("click", () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'product_name': sessionStorage.getItem("page-title"),
                        'product_id': ShopifyAnalytics.meta.page.resourceId,
                        'zone_location': sessionStorage.getItem("page-title"),
                        'event': 'reviews_check',
                    });
                })
            })
        }
    }

    // --> single_news
    if (document.querySelectorAll(".article-card__content a")) {
        document.querySelectorAll(".article-card__content a").forEach((single_news, index) => {
            single_news.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': single_news.closest(".article-card__content")?.querySelector(".article-card__title")?.textContent,
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'single_news'
                });
            })
        })
    }

    // --> follow_us
    if (document.querySelectorAll(".footer__socials a")) {
        document.querySelectorAll(".footer__socials a").forEach((follow_us, index) => {
            follow_us.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': follow_us.textContent.replace(/[\r\n]/g, '').replace(/\s+/g, ' ').replace(/ >/g, '>').replace(/> </g, '><').trim(),
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'follow_us'
                });
            })
        })
    }


    // --> useful_link
    if (document.querySelectorAll("carousel-element a")) {
        document.querySelectorAll("carousel-element a").forEach((useful_link, index) => {
            useful_link.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': useful_link.textContent,
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'useful_link'
                });
            })
        })
    }

    // --> accordion_open
    if (document.querySelectorAll(".accordion details")) {
        document.querySelectorAll(".accordion details").forEach((accordion_open, index) => {
            accordion_open.addEventListener("click", () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'cta_clicked': accordion_open.textContent,
                    'zone_location': sessionStorage.getItem("page-title"),
                    'event': 'accordion_open'
                });
            })
        })
    }

    // --> view_search_results (predittiva, la pagina search è inserita come pixel)
    if (document.querySelector(".search__box")) {
        const targetNode = document.querySelector(".search__box");

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    console.log("A child node has been added or removed.");
                } else if (mutation.type === "attributes") {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'search_term': document.querySelector(".search__input")?.value,
                        'zone_location': 'Pagina Search',
                        'is_suggested': 'Yes',
                        'event': 'view_search_results'
                    });
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);




    }

}

window.addEventListener('CookiebotOnAccept', function() {
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        'ad_storage':              Cookiebot.consent.marketing   ? 'granted' : 'denied',
        'ad_user_data':            Cookiebot.consent.marketing   ? 'granted' : 'denied',
        'ad_personalization':      Cookiebot.consent.marketing   ? 'granted' : 'denied',
        'analytics_storage':       Cookiebot.consent.statistics  ? 'granted' : 'denied',
        'functionality_storage':   Cookiebot.consent.preferences ? 'granted' : 'denied',
        'personalization_storage': Cookiebot.consent.preferences ? 'granted' : 'denied',
      });
    }
    
    if (typeof zooExpertTrackingGtm === 'function') zooExpertTrackingGtm();

    if (window?.Shopify && window?.Shopify?.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                analytics:   Cookiebot.consent.statistics,
                marketing:   Cookiebot.consent.marketing,
                preferences: Cookiebot.consent.preferences,
            },
            () => console.log('Shopify consent updated')
        );
    }
});

window.addEventListener('CookiebotOnDecline', function() {
    console.info('Consent Declined');
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        'ad_storage':              'denied',
        'ad_user_data':            'denied',
        'ad_personalization':      'denied',
        'analytics_storage':       'denied',
        'functionality_storage':   'denied',
        'personalization_storage': 'denied',
      });
    }
    if (window?.Shopify && window?.Shopify?.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                analytics:   Cookiebot.consent.statistics,
                marketing:   Cookiebot.consent.marketing,
                preferences: Cookiebot.consent.preferences,
            },
            () => console.log('Shopify consent updated')
        );
    }
});

window.addEventListener('load', ()=>{
    window?.Shopify?.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        (error) => {
            if (error) {
                console.error(error); // if you want to raise
            }
        },
    )
    zooExpertTrackingGtm();
})